import { useLang } from "@/contexts/LangContext";
import { Languages } from "lucide-react";

export default function LangToggle({ compact = false }: { compact?: boolean }) {
  const { lang, toggle } = useLang();
  const nextLabel = lang === "en" ? "বাংলা" : "English";
  const currentLabel = lang === "en" ? "EN" : "BN";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch language to ${nextLabel}`}
      title={`Switch to ${nextLabel}`}
      className="inline-flex items-center gap-1.5 h-9 px-3 rounded-full border border-[#e2e8f0] bg-white hover:border-[#9ce6cd] hover:bg-[#e6faf3] text-[12.5px] font-semibold text-[#0f172a] transition focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1ba179]/50 focus-visible:ring-offset-2 focus-visible:ring-offset-white"
      style={{ fontFamily: lang === "bn" ? "'Noto Sans Bengali', 'Inter', sans-serif" : undefined }}
    >
      <Languages className="w-3.5 h-3.5 text-[#1ba179]" aria-hidden />
      {compact ? currentLabel : (
        <>
          <span className="tabular-nums">{currentLabel}</span>
          <span aria-hidden className="text-[#cbd5e1]">·</span>
          <span className="text-[#64748b] font-medium">{nextLabel}</span>
        </>
      )}
    </button>
  );
}
